<kt-base-modal [showFooter]="true" title="Pending Form">
    <div modal-body>
        <kt-loader [showLoader]="loading()">
            <div class="alert alert-solid-warning alert-bold ">
                <span>
                  <svg-icon class="svg_icon31x38 w-20-warnig alert-svg" src="assets/media/iq-svg/without_circle/icon_set_3/warning.svg"></svg-icon>
                </span>
                <span>
                  <ul class="ms-n4">
                    <b> Completing this form is mandatory prior to starting your shift.</b>
                  </ul>
                </span>
              </div>
            <div style="height: calc(100vh - 470px) !important; overflow-y: auto; overflow-x: hidden;">

                <div class="kt-portlet kt-portlet--bordered" *ngFor="let item of pendingFormList()">
                    <div class="kt-widget4 p-3">
                        <div class="kt-widget4__item">
                            <div class="kt-widget4__pic kt-widget4__pic--pic">
                                <svg-icon class="task-top-icon_task-group-template me-2"
                                    *ngIf="!item?.master_task_group_template_image_url" src="assets/media/iq-svg/with_circle/icon_set_5/task_list.svg"></svg-icon>
                                <div class="task-top-icon_task-group-template d-inline me-2"
                                    *ngIf="item?.master_task_group_template_image_url">
                                    <img [src]="item?.master_task_group_template_image_url" alt="Template Image"
                                        class="me-2" />
                                </div>
                            </div>
                            <div class="kt-widget4__info">
                                <span class="kt-widget4__username">
                                {{item?.form?.form_name}} 
                                </span>
                            </div>
                            <button type="button" class="btn btn-success btn-sm kt-mr-5"
                                (click)="fillForm(item);">Fill Form</button>
                        </div>
                    </div>

                </div>

                <ng-container *ngIf="pendingFormList()?.length === 0 && !loading()">
                    <kt-no-record-found [noRecordFound]="noRecordFound"></kt-no-record-found>
                </ng-container>

            </div>
        </kt-loader>

    </div>
    <div modal-footer>
        <div class="float-start">
            <button type="button" class="btn btn-outline-brand float-start" data-bs-dismiss="modal"
                (click)="activeModal.close('Close')">Close</button>
        </div>
    </div>
</kt-base-modal>